
import * as constants from '../Constatnts'
import axios from 'axios';


export function saveAppointment(appointment, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/appoinment/${key}`,
          appointment,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/appoinment`,
          appointment,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function getAppointments(storeID, appointmentDate) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/getappoinments`,
        {
          params: {
            storeID,
            appointmentDate,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const appointmentList = response.data.appointments || [];
      return appointmentList;

    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getAppointmentsForAPeriod(fromDate, toDate) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/getappointmentsforperiod`,
        {
          params: {
            fromDate, toDate
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const appointmentList = response.data.appointments || [];
      return appointmentList;

    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function updateAppointmentStatus(status, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const data={
        Status:status
      }
      const response = await axios.put(
        `${constants.API_URL}/appoinment/${key}`,
        data,
        {
        
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );

      return key;

    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function cancelAppointment(CancellationReason, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.put(
        `${constants.API_URL}/appoinment/cancel/${key}`,
        {
          CancellationReason,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return key;

    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getAllAppointments(storeID, startDate, endDate, employeeID, status) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/getallappoinments`,
        {
          params: {
           storeID,
            startDate,
            endDate,
            employeeID,
            status
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const appointmentList = response.data.appointments || [];
      return appointmentList;

    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function getUpcomingAppointmentsForCustomer(customerID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/appoinment/upcomming/customer/${customerID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const appointmentList = response.data.appointments || [];
      return appointmentList;

    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getPastAppointmentsForCustomer(customerID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/appoinment/past/customer/${customerID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const appointmentList = response.data.appointments || [];
      return appointmentList;

    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getAppointmentsForCustomer(customerID, appointmentDate) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
       let startDate = new Date(appointmentDate).setHours(0, 0, 0, 0);
    let endDate = new Date(appointmentDate).setHours(23, 59, 0, 0);

      const response = await axios.get(
        `${constants.API_URL}/appoinment/customer/${customerID}`,
        {
          params: {
             startDate,
            endDate,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const appointmentList = response.data.appointments || [];
      return appointmentList;

    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

